<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24" v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择" default-value v-model="query.tenantId" allow-clear>
                <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId"
                  >{{ item.tenantName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="客户端ID">
              <a-input v-model="query.clientId" placeholder="请输入客户端ID" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="状态">
              <a-select placeholder="请选择" default-value v-model="query.status">
                <a-select-option value>全部</a-select-option>
                <a-select-option :value="0">正常</a-select-option>
                <a-select-option :value="1">禁用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()" v-action:add
                >新增</a-button
              >

              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      size="middle"
      rowKey="id"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <a-tag color="blue" slot="status" slot-scope="text">{{ text === 1 ? '禁用' : '正常' }}</a-tag>
      <span slot="status" slot-scope="text">
        <a-tag color="rgb(255, 99, 71)" v-if="text == 1">禁用</a-tag>
        <a-tag color="rgb(50, 205, 50)" v-else>正常</a-tag>
      </span>
      <a-tag color="blue" slot="waterBigStatus" slot-scope="text">{{ text === 1 ? '用水大户' : '普通用户' }}</a-tag>
      <span slot="createTime" slot-scope="text">{{ text | moment }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)" v-action:edit>编辑</a>
      </span>
    </a-table>
    <a-modal
      title="操作"
      style="top: 20px"
      :width="800"
      v-model="addOrUpdateVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form class="tenant-form" :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="客户端ID" hasFeedback>
          <a-input
            placeholder="客户端ID"
            v-decorator="['clientId', { rules: [{ required: true, message: '客户端ID' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
          <a-select
            placeholder="请选择"
            default-value
            v-decorator="[
              'status',
              { initialValue: 0 },
              { rules: [{ required: true, message: '请选择状态' }], initialValue: 0 },
            ]"
          >
            <a-select-option :value="0">正常</a-select-option>
            <a-select-option :value="1">禁用</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- <importModal
      ref="importModal"
      :tree-data="zoneTreeData"
      exportUrl="/pipe-network/water_associated_points/import"
      @close="close"
    ></importModal> -->
    <history-modal ref="historyModal"></history-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import HistoryModal from '../module/waterHistoryModal'
// import importModal from '@/views/pipenetwork/module/ImportModal'

const STATUS = {
  1: '正常',
  2: '禁用',
}
const columns = [
  {
    title: '客户端ID',
    dataIndex: 'clientId',
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' },
  },
  {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  components: {
    HistoryModal,
  },
  mixins: [mixinViewModule],
  name: 'SysClientApiKeys',
  data() {
    return {
      importLoading: false,
      fileList: [],
      queryUrl: 'pipe-network/sys_client_api_keys/page',
      addOrUpdateUrl: 'pipe-network/sys_client_api_keys',
      queryOneUrl: 'pipe-network/sys_client_api_keys',
      deleteUrl: 'pipe-network/sys_client_api_keys',
      query: {
        clientId: '',
        tenantId: this.$store.state.user.info.tenantId,
        status: '',
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
    }
  },
  filters: {
    statusFilter(key) {
      return STATUS[key]
    },
    permissionFilter(key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    },
  },
  created() {
    // this.getZoneData()
    this.getAllTenant()
  },
  methods: {
    handleOk(e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          var params = {
            id: this.currentId,
            ...values,
          }
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, params)
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    },
    // getZoneData() {
    //   this.$http.get(this.queryZoneDateUrl).then(({data}) => {
    //     this.zoneTreeData = data
    //   })
    // },
    historyData() {
      this.$refs.historyModal.show()
    },
    // 关闭选择分区页面时
    close(val) {
      console.log(val)
      this.zoneId = val
      this.openSelectFile = true
    },
    importHandle() {
      console.log('导入按钮')
      this.$refs.importModal.show()
    },
    changeFile(info) {},
    customRequest(data) {
      // 上传提交
      console.log('123')
      const formData = new FormData()
      formData.append('file', data.file)
      formData.append('zone_id', this.zoneId)
      this.saveFile(formData)
    },
    saveFile(formData) {
      this.importLoading = true
      this.axios({
        method: 'post',
        url: '/pipe-network/water_associated_points/import',
        headers: {},
        params: {},
        data: formData,
      })
        .then((response) => {
          if (response.code === 0) {
            this.queryList()
            this.$message.success(response.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          this.importLoading = false
        })
    },
  },
  watch: {},
}
</script>

<style lang="less" scoped>
.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
